import './bootstrap'

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

// Edytor notatek rejestruje init na DOMContentLoaded — musi być importowany
// statycznie (przed startem), żeby zdążył podpiąć listener.
import './note-quill'

import assigneePicker from './assignee-picker'

// Start Alpine ZANIM załadujemy moduł PWA. Moduł PWA dotyka "kruchych" API
// (Service Worker, IndexedDB, push) i jego błąd nie może zablokować startu
// Alpine — inaczej znika cała treść zależna od Alpine (navbar + biały ekran).
Alpine.plugin(collapse)

window.Alpine = Alpine

// Rejestracja musi nastąpić PRZED Alpine.start(), inaczej x-data="assigneePicker(...)"
// nie znajdzie komponentu.
Alpine.data('assigneePicker', assigneePicker)

Alpine.start()

// Moduł PWA: ładowany po starcie Alpine; błąd/404 jest łapany i tylko logowany.
import('./pwa/index.js').catch((e) => console.error('[app] moduł PWA nie załadowany:', e))

// Initialize Pusher for real-time notifications using Laravel Echo
if (typeof window.userId !== 'undefined' && window.Echo) {
    const channel = window.Echo.private(`notifications.user.${window.userId}`);

    channel.listen('.notification.created', function(data) {
        console.log('New notification received:', data);

        // Update unread count
        if (typeof updateUnreadCount === 'function') {
            // Get current count and increment
            const currentCount = document.querySelector('[x-text="unreadCount"]')?.__x?.$data?.unreadCount || 0;
            updateUnreadCount(currentCount + 1);
        }

        // Show toast notification
        if (typeof showNotification === 'function') {
            showNotification(`Nowe powiadomienie: ${data.message}`, 'info');
        }

        // Optionally refresh the notifications dropdown content
        // This would require an API call to get fresh notifications HTML
    })
    .subscribed(() => {
        console.log('Successfully subscribed to notifications channel');
    })
    .error((error) => {
        console.error('Failed to subscribe to notifications channel:', error);
    });
}

// ⬇️ Nic z FullCalendar tutaj.
// Kalendarz inicjalizujemy BEZPOŚREDNIO w widoku Blade (schedule.index)
// poprzez <script src="...fullcalendar..."> z CDN i tamtejszy init.
